import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import "./AccessDenied.css";

/**
 * AccessDenied Component
 *
 * Displays a message when a user’s account is not yet activated.
 * Retrieves the active MSAL account or falls back to the first available account.
 * Provides a mailto link to request access, using support and CC emails from environment variables.
 */
const AccessDenied = () => {
  const { instance } = useMsal();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    // Attempt to get the currently active authenticated account
    let account = instance.getActiveAccount();

    // If no active account, fall back to the first available account
    if (!account) {
      const allAccounts = instance.getAllAccounts();
      if (allAccounts.length > 0) {
        account = allAccounts[0];
        instance.setActiveAccount(account); // Optionally set this account as active
      }
    }

    // If an account is found, update state
    if (account) {
      setUserName(account.name);
      setUserEmail(account.username);
    }
  }, [instance]);

  // Read support and CC email addresses from environment variables with fallback defaults
  const supportEmail =
    process.env.REACT_APP_SUPPORT_EMAIL || process.env.REACT_APP_SUPPORT_EMAIL;
  const ccEmail =
    process.env.REACT_APP_CC_EMAIL || process.env.REACT_APP_CC_EMAIL;

  // Construct mailto link with subject containing user name and email
  const mailToLink = `mailto:${supportEmail}?subject=Access Request GTM Factory - ${encodeURIComponent(
    userName
  )} (${encodeURIComponent(userEmail)})&cc=${ccEmail}`;

  return (
    <div className="access-denied-container">
      <div className="access-denied-text">
        <h2>Welcome to Mobility - GTM Factory</h2>
        <p>Your account has not been activated yet.</p>
        <p>
          To start your journey please{" "}
          <a href={mailToLink} className="signup-link">
            Click Here
          </a>{" "}
          to raise access request.
        </p>
      </div>
    </div>
  );
};

export default AccessDenied;
